import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const AgentProfileRedirect = props => (
  <Redirect
    from="/applications/:applicationId"
    to={{
      pathname: `/applications/company-profile/${props.match.params.applicationId}`,
      search: props.location.search,
    }}
  />
);

AgentProfileRedirect.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      applicationId: PropTypes.string,
    }),
  }).isRequired,
};

export default AgentProfileRedirect;
